/**
 * @fileoverview POST handler for the "/apps/user_info/confirm_user_deletion" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppsUserInfoConfirmUserDeletionCacheKeys } from "./constants";
import type { PostAppsUserInfoConfirmUserDeletionProps, PostAppsUserInfoConfirmUserDeletionResult } from "./types";

export const postAppsUserInfoConfirmUserDeletion = reactQueryMutationAdapter(
  postAppsUserInfoConfirmUserDeletionCacheKeys,
  (props: PostAppsUserInfoConfirmUserDeletionProps): Promise<PostAppsUserInfoConfirmUserDeletionResult> => {
    // manipulate props here as needed deletion_record_id

    return fetch("/apps/user_info/confirm_user_deletion", "POST", props, undefined, {
      // don't display a modal on fetch errors
      propagateFetchRequestError: false,
    });
  }
);
